// or your router
import { Box } from "@mui/material";
import { AnchorHTMLAttributes, ClassAttributes } from "react";
import { ExtraProps } from "react-markdown";

import { MarkdownElCommonProps } from "../MarkdownRenderer";

type Props = ClassAttributes<HTMLImageElement> &
  AnchorHTMLAttributes<HTMLImageElement> &
  ExtraProps &
  MarkdownElCommonProps;

/** <img src="" /> element. */
export function MarkdownImgEl({ sx, node, children, ...otherProps }: Props) {
  return (
    <Box
      component='img'
      sx={{
        maxWidth: "100%",
        border: (th) => `1px solid ${th.palette.divider}`,
        borderRadius: (th) => th.shapeCustom.borderRadiusImage,
        // boxShadow: (th) => th.shadows[1],
        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </Box>
  );
}
